import { initializeApp } from 'firebase/app';
import { firebaseConfig } from './config';
import { getStorage } from 'firebase/storage';
export var app = initializeApp(firebaseConfig);
var storage = getStorage(app);
var firebaseApp = { app: app, storage: storage };
export default firebaseApp;
